import { render } from "./AssessmentProfileLayout.vue?vue&type=template&id=064f3d22&scoped=true"
import script from "./AssessmentProfileLayout.vue?vue&type=script&lang=js"
export * from "./AssessmentProfileLayout.vue?vue&type=script&lang=js"

import "./AssessmentProfileLayout.vue?vue&type=style&index=0&id=064f3d22&lang=scss&scoped=true"
import "./AssessmentProfileLayout.vue?vue&type=style&index=1&id=064f3d22&lang=scss"
script.render = render
script.__scopeId = "data-v-064f3d22"

export default script